import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, ShoppingCart, X } from "lucide-react";
import Logo from "./Logo";
import { useCart } from "../context/CartContext";

const LINKS = [
    { to: "/", label: "Home", testId: "nav-home-link" },
    { to: "/about", label: "About", testId: "nav-about-link" },
    { to: "/products", label: "Products", testId: "nav-products-link" },
    { to: "/contact", label: "Contact", testId: "nav-contact-link" },
];

const Navbar = () => {
    const { count, setOpen } = useCart();
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <>
        <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
            <div className="flex items-stretch justify-between h-16 md:h-20">
                <div className="flex items-center px-4 md:px-8 border-r border-white/10">
                    <Logo />
                </div>

                <nav className="hidden md:flex items-stretch" data-testid="desktop-nav">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={l.testId}
                            className={({ isActive }) =>
                                `flex items-center px-6 font-mono text-xs tracking-[0.2em] uppercase border-l border-white/10 transition-colors duration-300 ${
                                    isActive ? "text-[#FF5C00]" : "text-white/70 hover:text-white"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <button
                        data-testid="nav-cart-button"
                        onClick={() => setOpen(true)}
                        className="relative flex items-center px-6 border-l border-white/10 text-white/70 hover:text-white transition-colors duration-300"
                        aria-label="Open enquiry cart"
                    >
                        <ShoppingCart className="w-4 h-4" />
                        {count > 0 && (
                            <span data-testid="nav-cart-count" className="absolute top-3 right-3 bg-[#FF5C00] text-black font-mono text-[10px] font-semibold w-4 h-4 flex items-center justify-center">
                                {count}
                            </span>
                        )}
                    </button>
                    <Link
                        to="/products"
                        data-testid="nav-view-products-cta"
                        className="hidden lg:flex items-center px-8 border-l border-white/10 bg-[#FF5C00] text-white font-mono text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-colors duration-300"
                    >
                        View Products
                    </Link>
                </nav>

                <div className="flex md:hidden items-stretch">
                    <button
                        data-testid="nav-cart-button-mobile"
                        onClick={() => setOpen(true)}
                        className="relative flex items-center px-5 border-l border-white/10 text-white"
                        aria-label="Open enquiry cart"
                    >
                        <ShoppingCart className="w-5 h-5" />
                        {count > 0 && (
                            <span className="absolute top-2 right-2 bg-[#FF5C00] text-black font-mono text-[10px] font-semibold w-4 h-4 flex items-center justify-center">
                                {count}
                            </span>
                        )}
                    </button>
                    <button
                        data-testid="nav-mobile-menu-button"
                        onClick={() => setMobileOpen(true)}
                        className="flex items-center px-5 border-l border-white/10 text-white"
                        aria-label="Open menu"
                    >
                        <Menu className="w-5 h-5" />
                    </button>
                </div>
            </div>

        </header>

        {mobileOpen && (
                <div className="fixed inset-0 z-[60] bg-[#050505] flex flex-col" data-testid="mobile-menu">
                    <div className="flex items-center justify-between h-16 px-4 border-b border-white/10">
                        <Logo />
                        <button
                            data-testid="nav-mobile-close-button"
                            onClick={() => setMobileOpen(false)}
                            className="p-2 text-white"
                            aria-label="Close menu"
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>
                    <nav className="flex flex-col">
                        {LINKS.map((l, i) => (
                            <button
                                key={l.to}
                                data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
                                onClick={() => { setMobileOpen(false); navigate(l.to); }}
                                className="text-left font-heading font-extrabold uppercase tracking-tight text-4xl px-6 py-5 border-b border-white/10 text-white hover:text-[#FF5C00] transition-colors duration-300"
                            >
                                <span className="font-mono text-xs text-[#FF5C00] mr-4 align-middle">0{i + 1}</span>
                                {l.label}
                            </button>
                        ))}
                    </nav>
                    <Link
                        to="/products"
                        data-testid="mobile-view-products-cta"
                        onClick={() => setMobileOpen(false)}
                        className="mt-auto m-6 flex items-center justify-center h-14 bg-[#FF5C00] text-white font-mono text-sm tracking-[0.2em] uppercase"
                    >
                        View Products
                    </Link>
                </div>
            )}
        </>
    );
};

export default Navbar;
